import React, { useState, useRef, useEffect } from "react";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import { canvasPreview } from "../../../pages/canvasPreview";
import { useDebounceEffect } from "../../../pages/useDebounceEffect";
import { createCanvas } from 'canvas';


import "react-image-crop/dist/ReactCrop.css";
import Service from "../../../services";
import FileInputWithLabel from "../../../commonfields/FileInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowLeft, faArrowRight, faEraser, faSearchMinus, faSearchPlus, faXmark } from "@fortawesome/free-solid-svg-icons";

// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
}

export default function ImgCropComponent(props:any) {
  const [imgSrc, setImgSrc] = useState<any>();
  const [multipleImg, setMultipleImg] = useState<any>();
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  // const hiddenAnchorRef = useRef<HTMLAnchorElement>(null);
  // const blobUrlRef = useRef("");
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [scale, setScale] = useState<any>(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState<number | undefined>();

  // const  clearImage = () =>{
    useEffect(() => {
      props?.setCropClear(false);
      setCrop(undefined);
      clear()
    }, [props?.cropClear])

  useEffect(()=>{
    if(props?.testFile){
      onSelectFile(props?.documentFile)
    }
    props?.setTestFile(false)
  },[props?.testFile])
    
  const [isSingle,setIsSingle] = useState(false)
  function onSelectFile(files: any) {
    if(files?.length > 0){
       // @ts-ignore
      const pdfjsLib = window['pdfjs-dist/build/pdf'];
      const file:any = files[0];
          if (file && file.type === 'application/pdf' || file && file.type === 'pdf') {
                  convertPdfToImages(file);
                  setCrop(undefined); // Makes crop preview update between images.
                  setIsSingle(false)
          } else {
            if (files && files.length > 0) {
              setIsSingle(true)
                setCrop(undefined); // Makes crop preview update between images.
                const reader = new FileReader();
                reader.onload = function () {
                const dataUrl = reader.result;
                console.log(dataUrl); // This will be your Data URL
                setImgSrc(dataUrl);
                };

                reader.readAsDataURL(files[0]);
                console.log( files[0] instanceof Blob);
            }
          }
    }else{
      setImgSrc(undefined)
    }
  }

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      // setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  const service = new Service();

  const handleUpload = () => {
    const canvas = previewCanvasRef.current;

    if (!canvas) {
      console.error('Canvas not found');
      return;
    }

    // Get the image data from the canvas
    const imageDataURL = canvas.toDataURL('image/png');

    // Convert the image data to a Blob
    fetch(imageDataURL)
      .then((res) => res.blob())
      .then((blob) => {
        props?.setCroppedImageBlob(blob)
        props.gpt_vision()
      })
      .catch((error) => {
        console.error('Error converting image data to Blob', error);
      });
    }

    const convertPdfToImages = async (pdfFile:any) => {
       // @ts-ignore
      const pdfjsLib = window['pdfjs-dist/build/pdf'];
      if(pdfFile?.value){
        const binaryString = atob(pdfFile?.value);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/pdf' });
        const reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onload = async function(event:any) {
          const arrayBuffer = event.target.result;
          const pdfDocument = await pdfjsLib.getDocument({ data:arrayBuffer }).promise;
          const imagesArray = [];
          for (let pageNumber = 1; pageNumber <= pdfDocument.numPages; pageNumber++) {
            const page = await pdfDocument.getPage(pageNumber);
            const viewport = page.getViewport({ scale: 2 });
            const canvas = createCanvas(viewport.width, viewport.height);
            const context = canvas.getContext('2d');
            await page.render({ canvasContext: context, viewport }).promise;
            const imageSrc = canvas.toDataURL('image/png');
            imagesArray.push(imageSrc);
          }
          setMultipleImg(imagesArray)
          setImgSrc(imagesArray[0])
        };
          }
      else{
            const data = await pdfFile.arrayBuffer();
            const pdfDocument = await pdfjsLib.getDocument({ data }).promise;
            const imagesArray = [];
            for (let pageNumber = 1; pageNumber <= pdfDocument.numPages; pageNumber++) {
              const page = await pdfDocument.getPage(pageNumber);
              const viewport = page.getViewport({ scale: 2 });
              const canvas = createCanvas(viewport.width, viewport.height);
              const context = canvas.getContext('2d');
              await page.render({ canvasContext: context, viewport }).promise;
        
              const imageSrc = canvas.toDataURL('image/png');
              imagesArray.push(imageSrc);
            }
            setMultipleImg(imagesArray)
            setImgSrc(imagesArray[0])
          }
    }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
        );
        const imageDataURL = previewCanvasRef.current.toDataURL('image/png');
        props?.setCroppedImage(imageDataURL);


        const canvas = previewCanvasRef.current;

        if (!canvas) {
          console.error('Canvas not found');
          return;
        }
         // Get the image data from the canvas
    const imageDataURL2 = canvas.toDataURL('image/png');

    // Convert the image data to a Blob
    fetch(imageDataURL2)
      .then((res) => res.blob())
      .then((blob) => {
        props?.setCroppedImageBlob(blob)
        // props.gpt_vision()
      })
      .catch((error) => {
        console.error('Error converting image data to Blob', error);
      });

      }
    },
    100,
    [completedCrop, scale, rotate],
  );

  function handleToggleAspectClick() {
    if (aspect) {
      setAspect(undefined);
    } else {
      setAspect(16 / 9);

      if (imgRef.current) {
        const { width, height } = imgRef.current;
        const newCrop = centerAspectCrop(width, height, 16 / 9);
        setCrop(newCrop);
        // Updates the preview
        setCompletedCrop(convertToPixelCrop(newCrop, width, height));
      }
    }
  }
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % multipleImg?.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + multipleImg?.length) % multipleImg?.length);
  };

  useEffect(() => {
    setCurrentIndex(0);
  }, [multipleImg]);

  const clear = () =>{
    setCrop(undefined);
    setScale(1)
  }
  return (
    <div>
      <div className="control-options">
      {/* {props?.documentOptionPanel()} */}
      <div className="Crop-Controls">
        <button disabled={!imgSrc}><FontAwesomeIcon icon={faXmark} onClick={()=>clear()}/></button>
        <button disabled={!imgSrc}><FontAwesomeIcon icon={faArrowLeft} onClick={()=>prevSlide()}/></button>
        <button disabled={!imgSrc}><FontAwesomeIcon icon={faArrowRight} onClick={()=>nextSlide()} /></button>
        <button disabled={!imgSrc}><FontAwesomeIcon icon={faSearchMinus}  onClick={()=>setScale(Number(scale-0.1))}/></button>
        <button disabled={!imgSrc}><FontAwesomeIcon icon={faSearchPlus} onClick={()=>setScale(Number(scale+0.1))}/></button>

        {/* <div>
          <input
            id="scale-input"
            type="number"
            step="0.1"
            value={scale}
            disabled={!imgSrc}
            placeholder="scale" 
            // style={ {color: '#1D98B6',
            //   height: '33px',
            //   width: '80px'}}
            onChange={(e) => setScale(Number(e.target.value))}
          />
        </div> */}
      </div>
      
      </div>
      <div className="react-crop-panel">
      {!!imgSrc && (
        <ReactCrop
          crop={crop}
          onChange={(_, percentCrop) => setCrop(percentCrop)}
          onComplete={(c) => setCompletedCrop(c)}
          aspect={aspect}
          // minWidth={400}
          minHeight={100}
          // circularCrop
        >
          <img
            ref={imgRef}
            alt="Crop me"
            src={isSingle ? imgSrc : multipleImg[currentIndex]}
            className="react-crop-image"
            style={{ transform: `scale(${scale}) rotate(${rotate}deg)`, maxWidth:"620px", border:'2px solid tranparant' }}
            onLoad={onImageLoad}
          />
        </ReactCrop>
      )}
      {!!completedCrop && (
        <>
          <div>
            <canvas
              ref={previewCanvasRef}
              style={{
                border: "1px solid black",
                objectFit: "contain",
                width: '10px',
                height: '10px',
                display:'none'
              }}
            />
          </div>
        </>
      )}
      </div>
    </div>
  );
}
